// Fonctions pures v4.4.2 : listes, mentions et préférence visuelle.
export function normalizeShoppingTextItems(value, limit = 200) {
  const out = []; const seen = new Set();
  for (const raw of Array.isArray(value) ? value : []) {
    if (raw === null || raw === undefined) continue;
    const text = String(typeof raw === 'object' ? raw.text ?? '' : raw).trim();
    const key = text.toLocaleLowerCase('fr');
    if (!text || seen.has(key)) continue;
    seen.add(key); out.push(text);
    if (out.length >= limit) break;
  }
  return out;
}
export function mergeShoppingItems(current, incoming, onlyNew = true, idFactory = () => crypto.randomUUID()) {
  const base = Array.isArray(current) ? current.filter((x) => x && typeof x.text === 'string') : [];
  const existing = new Set(base.map((x) => x.text.trim().toLocaleLowerCase('fr')));
  const texts = normalizeShoppingTextItems(incoming).filter((x) => !onlyNew || !existing.has(x.toLocaleLowerCase('fr')));
  return { items: [...base, ...texts.map((text) => ({ id: idFactory(), text, checked: false }))], added: texts.length };
}
export function collectMentions(text, members, selfPseudo = '') {
  const value = String(text || '');
  return [...new Set((Array.isArray(members) ? members : []).map(String).filter((pseudo) => {
    if (!pseudo || pseudo === selfPseudo) return false;
    const escaped = pseudo.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp(`(^|\\s)@${escaped}(?=\\s|$|[.,!?;:])`, 'u').test(value);
  }))];
}
export function normalizeUiStyle(value) { return value === 'modern' ? 'modern' : 'classic'; }
